var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuExport = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5312 2.21885C10.2375 1.9251 9.7625 1.9251 9.47188 2.21885L5.46875 6.21885C5.175 6.5126 5.175 6.9876 5.46875 7.27822C5.7625 7.56885 6.2375 7.57197 6.52813 7.27822L9.24687 4.55947L9.25 12.2501C9.25 12.6657 9.58437 13.0001 10 13.0001C10.4156 13.0001 10.75 12.6657 10.75 12.2501V4.55947L13.4688 7.27822C13.7625 7.57197 14.2375 7.57197 14.5281 7.27822C14.8187 6.98447 14.8219 6.50947 14.5281 6.21885L10.5312 2.21885ZM4.5 12.7501C4.5 12.3345 4.16562 12.0001 3.75 12.0001C3.33437 12.0001 3 12.3345 3 12.7501V15.2501C3 16.7688 4.23125 18.0001 5.75 18.0001H14.25C15.7688 18.0001 17 16.7688 17 15.2501V12.7501C17 12.3345 16.6656 12.0001 16.25 12.0001C15.8344 12.0001 15.5 12.3345 15.5 12.7501V15.2501C15.5 15.9407 14.9406 16.5001 14.25 16.5001H5.75C5.05938 16.5001 4.5 15.9407 4.5 15.2501V12.7501Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuExport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "9995b4a0c7ea13f020a7eb5c083a144e.svg";